(function (angular) {
    'use strict';
    angular.module("dentist").controller('doneController', doneController);

    function doneController(dentistService, appointmentService, $translate, $stateParams) {

        //controller initialization
        var ctrl = this;
        ctrl.changeLanguage = changeLanguage;
        ctrl.isMentorBooking = isMentorBooking;
        
        function changeLanguage(langKey) {
            $translate.use(langKey);
            localStorage.setItem("lang", langKey);
        }

        ctrl.practiceId = angular.copy(localStorage.getItem("practiceId"));
        ctrl.practiceName = angular.copy(localStorage.getItem("practiceName"));
        ctrl.dentistName = angular.copy(localStorage.getItem("dentistName"));
        ctrl.serviceName = angular.copy(localStorage.getItem("serviceName"));
        ctrl.selectedService = JSON.parse(localStorage.getItem("selectedServiceObject"));
        ctrl.serviceID = angular.copy(localStorage.getItem("serviceID"));
        ctrl.practitionerId = angular.copy(localStorage.getItem("practitionerId"));
        ctrl.selectedDate = angular.copy(moment(localStorage.getItem("selectedDate")).toDate());
        ctrl.selectedTime = angular.copy(localStorage.getItem("selectedTime"));
        ctrl.practiceAddress = angular.copy(localStorage.getItem("practiceAddress"));
        ctrl.bookingReference = angular.copy(localStorage.getItem("bookingReference"));
        ctrl.servicePrice = angular.copy(localStorage.getItem("servicePrice"));
        ctrl.voucherDeduction = angular.copy(localStorage.getItem("voucherDeduction") == "undefined" ? "": localStorage.getItem("voucherDeduction"));
        ctrl.voucherDeductionDescription = angular.copy(localStorage.getItem("voucherDescription") == "undefined" ? "": localStorage.getItem("voucherDescription"));
        ctrl.resultingPrice = angular.copy(localStorage.getItem("resultingPrice") == "undefined" ? "": localStorage.getItem("resultingPrice"));
        
        ctrl.practiceBookingTerms = angular.copy(localStorage.getItem("practiceBookingTerms") == "undefined" ? "": localStorage.getItem("practiceBookingTerms"));
        ctrl.practiceBookingTerms = ctrl.practiceBookingTerms.split('\n');
        
        ctrl.isStandaloneBooking = $stateParams.standalone;

        if (ctrl.dentistName == null || ctrl.serviceName == null || ctrl.selectedDate == null || ctrl.dentistName == '' || ctrl.serviceName == '' || ctrl.selectedDate == '') {
            window.location = "index.html";
        }

        submitCustomerAnalytics();

        function isMentorBooking() {
        	return ($stateParams.practiceId == 29852);
        }

        function submitCustomerAnalytics() {
            // hardcoded trackingIds for practices Dr. Frei. Replace with practice fields, once more customer demand arises
            ctrl.practiceAnalyticsCode = ctrl.practiceId == 8202 ? ($rootScope.bookingStyle ? 'UA-40535209-2' : 'UA-40535209-1') : null;

            if (ctrl.isStandaloneBooking && ctrl.practiceAnalyticsCode) {
                var s = document.createElement( 'script' );
                document.body.appendChild( s );

                $(s).html("(function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){"+
                "(i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),"+
                "m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)"+
                "})(window,document,'script','https://www.google-analytics.com/analytics.js','ga');"+
                "ga('create', '" + ctrl.practiceAnalyticsCode + "', {'storage': 'none'});"+
                "ga('send', 'pageview');");
            }
        }

    }

    doneController.$inject = ['dentistService', 'appointmentService', '$translate', '$stateParams'];

})(window.angular);
